export default /*@ngInject*/ function () {
    const vm = this;

    vm.changeSelectedRequesterGroup = changeSelectedRequesterGroup;

    function changeSelectedRequesterGroup(requesterGroup) {
        vm.selectedRequesterGroup = requesterGroup;
    }
}